/**
 * /*
 * ******************************************************************
 * This is the main accordion box that splits out the checkout steps.
 * The process is divided in 4 steps: login, shipping, billing,
 * and payment. As the user moves forward the previous step
 * is closed displaying a summary of the data within that
 * step.
 * ****
 *
 * @format
 */

import {AccordionSection, CheckoutAccordion} from 'frontier/account/checkout_accordion';
import CheckoutShippingStep from 'frontier/cart/components/shipping/shipping_step';
import {PaymentStep} from 'frontier/cart/components/payments/payment_step';
import {BillingStep} from 'frontier/cart/components/billing/billing_step';
import React, {useEffect, useState} from 'react';
import {
    CartCheckoutContext,
    SHIPPING_STEP,
    BILLING_STEP,
    PAYMENT_STEP,
    LOGIN_STEP
} from 'frontier/cart/components/cart/cart_checkout_context';

export function CheckoutProcess() {
    const ctx = React.useContext(CartCheckoutContext);

    useEffect(() => {
        if (ctx.shipments.length === 0) {
            ctx.onSetCurrentStep(BILLING_STEP);
        }
    }, []);
    return (
        <CheckoutAccordion>
            <AccordionSection sectionId={LOGIN_STEP} title={'1. Customer'} isEditable={false}>
                <h5 className="mx-0 mb-2 mt-0 tw-p-0 user-company-label">
                    {ctx.cart.user.company_name
                        ? ctx.cart.user.company_name
                        : `${ctx.cart.user.first_name}'s company`}
                </h5>
                <p className="m-0 tw-p-0 user-email-label">{ctx.cart.user.email}</p>
            </AccordionSection>
            <AccordionSection
                sectionId={SHIPPING_STEP}
                isEditable={ctx.shipments.length === 0 ? false : true}
                title="2. Shipping"
                key={1}>
                <CheckoutShippingStep />
            </AccordionSection>
            <AccordionSection sectionId={BILLING_STEP} isEditable={true} title="3. Billing" key={2}>
                <BillingStep stepIsCompleted={ctx.currentStep > BILLING_STEP} />
            </AccordionSection>
            <AccordionSection sectionId={PAYMENT_STEP} title="4. Payment" key={3} isEditable={true}>
                <PaymentStep />
            </AccordionSection>
        </CheckoutAccordion>
    );
}
